module.exports = __webpack_public_path__ + "static/media/dashboard-icon.931e2724.svg";